// The AI photo editor's Ultra HD tier is hidden for now: its generate button and the Settings switch that enables it.
// Each user's saved `qualityUltraEnabled` stays as it is, so setting this to true brings both back. The Studio Editor keeps its own Ultra HD.
export const AI_PHOTO_ULTRA_HD = false;
